export const ERROR_TYPES = {
	EMPTY: 'EMPTY',
	CHAR_LIMIT_EXCEEDED: 'CHAR_LIMIT_EXCEEDED',
} as const;

export const MAX_URL_LENGTH = 2048;
export const MAX_TITLE_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 255;
export const MIN_ROWS_DESCRIPTION = 5;
export const MAX_FLAG_TITLE_LENGTH = 25;
export const MAX_NO_OF_LINKS_ALLOWED = 10;

export const MODES = {
	ADD: 'ADD',
	EDIT: 'EDIT',
} as const;

export const EXTERNAL_RESOURCES_DELETE_EXPERIENCE_ID =
	'service-management.delete.external-resources';
export const EXTERNAL_RESOURCES_ADD_UPDATE_EXPERIENCE_ID =
	'service-management.add-update.external-resources';
export const EXTERNAL_RESOURCES_REORDER_EXPERIENCE_ID =
	'service-management.reorder.external-resources';
